// Traductions du parcours « Compose ton lot » (même structure que FR dans i18n.js ; toute clé absente → français).
// Néerlandais : vocabulaire du site NL (klep/kleppen, taslichaam, riem, sluiting, bedel, pakket, winkelmandje),
// tutoiement (je) comme le reste du site ; relu par la session andjoy-site-3e le 18/10/2026. Espagnol et italien : tutoiement aussi ; anglais : you.
// terms : textes venus du configurateur en français (catégories, noms de produits, note de précommande).
// Les rabats sont listés sans leur préfixe « Rabat - ».

const NL = {
  locale: 'nl-NL',
  ord: ['1e', '2e', '3e'],
  ordH: ['1<sup>e</sup>', '2<sup>e</sup>', '3<sup>e</sup>'],
  ui: {
    loading: 'Laden…',
    loadError: 'Het pakket kan nu niet worden geladen. Vernieuw de pagina.',
    noLot: 'Geen pakket beschikbaar.',
    ariaPreview: 'Voorbeeld van je tas',
    ariaNav: 'Navigatie van het pakket',
    ariaSteps: 'Stappen van het pakket',
    composeLot: 'Stel je pakket samen met {badge}',
    seeRecap: 'Bekijk het overzicht',
    hoverSizeHere: 'Beweeg over een maat om hem hier te zien',
    captionWithFlap: '{size} · met de klep {flap}',
    captionFlapTodo: '{size} · klep nog te kiezen',
    captionStart: 'Kies je tas om te beginnen',
    removeAria: '{name} verwijderen',
    remove: 'Verwijderen',
    flapN: '{ord} klep',
    toChoose: 'Nog te kiezen',
    next: 'Volgende',
    checkout: 'Afrekenen',
    addToSelectionN: 'Toevoegen aan mijn selectie ({n})',
    update: 'Bijwerken',
    addToSelection: 'Toevoegen aan mijn selectie',
    recap: 'Overzicht',
    adding: 'Bezig met toevoegen…',
    added: '✓ Pakket toegevoegd!',
    addToCart: 'In mijn winkelmandje',
    deltaOnLot: '{delta} op je pakket',
    yourSelection: 'Jouw selectie',
    chooseSize: 'Kies een maat',
    fromPrice: 'vanaf {price}',
    bagPlus3: 'Tas + 3 kleppen',
    saved: '{amount} bespaard',
    shipBar: '+ Gratis verzending naar een afhaalpunt',
    prevStepAria: 'Vorige stap',
    prev: 'Vorige',
    stepBag: 'Tas',
    stepAccessories: 'Accessoires',
    backTo: 'Terug naar: {step}',
    dimsTitle: 'Hoogte × breedte × diepte',
    included: 'Inbegrepen: {items}',
    and: ' en ',
    inclClasp: 'sluiting ({name})',
    lotBag3: 'Pakket: tas + 3 kleppen',
    whichSize: 'Welke maat tas wil je?',
    takenAria: '{name}, al gekozen als {ord} klep',
    soldOutAria: '{name}, uitverkocht',
    soldOut: 'Uitverkocht',
    alreadyIncluded: 'Zit al in je pakket',
    includedAria: '{name}, zit al in je set',
    whichFlap: 'Kies je {ord} klep',
    prevFlapsAria: 'Vorige kleppen',
    nextFlapsAria: 'Volgende kleppen',
    hoverSize: 'Beweeg over een maat om hem links te zien.',
    hoverFlap: 'Beweeg over een klep om hem op je tas te passen.',
    askMore: 'Wil je nog meer accessoires met {pct} korting toevoegen?',
    askAnother: 'Wil je nog een accessoire met {pct} korting toevoegen?',
    tickHint: 'Vink aan wat je mooi vindt: je accessoires verschijnen links. Je kunt er meerdere kiezen.',
    accessoriesCount: { one: '{n} accessoire', other: '{n} accessoires' },
    selectionPlus: 'Jouw selectie + {count}',
    whichAccessory: 'Welk accessoire?',
    cancel: 'Annuleren',
    multiple: 'Je kunt er meerdere kiezen',
    notChosen: 'Nog niet gekozen',
    edit: 'Wijzigen',
    accessoryOf: 'Accessoire · {cat}',
    recapTitle: 'Jouw selectie met {pct} korting',
    totalPrice: 'Totaalprijs: {price}',
    lotPrice: 'Prijs van het pakket: {price}',
    youSave: 'Je bespaart: {amount}',
    shipRecap: '<b>Extra dankzij je pakket</b>: gratis verzending naar een afhaalpunt.',
    addAccessory: '+ Accessoire toevoegen met {pct} korting',
    chooseFlapsHint: 'Kies je 3 kleppen om het pakket in je winkelmandje te leggen.',
    doneTitle: 'Je pakket zit in je winkelmandje',
    doneSave: 'Je hebt {amount} bespaard.',
    doneSaveShip: 'Je hebt {amount} bespaard en de verzending naar een afhaalpunt is gratis.',
    another: 'Nog een pakket samenstellen',
    continueShopping: 'Verder winkelen',
    cartError: 'Het pakket kon niet aan je winkelmandje worden toegevoegd',
    cartWarning: 'Je pakket zit in je winkelmandje, maar een accessoire is niet meer beschikbaar en is niet toegevoegd.',
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Sluitingen',
    charmFirst: 'Kies eerst je bedel',
    claspStep1: 'Kies je geperforeerde sluiting',
    claspQ: 'Met of zonder bedel?',
    claspNo: 'Zonder bedel',
    claspNoHint: 'Sluiting zonder gaatje',
    claspYes: 'Met een bedel',
    claspYesHint: 'Geperforeerde sluiting + bedel om op te hangen',
    charmPick: 'Kies je bedel: hij hangt in het gaatje van de sluiting.',
    charmMissing: 'Je geperforeerde sluiting wacht nog op een bedel: zonder bedel blijft het gaatje leeg.',
    charmCta: 'Kies een bedel',
  },
  terms: {
    // catégories et note
    'Rabats': 'Kleppen', 'Sangles': 'Riemen', 'Fermoir non perforé': 'Sluitingen', 'Fermoir perforé': 'Geperforeerde sluitingen',
    'Charms': 'Bedels', 'Portefeuille': 'Portemonnees', 'Précommande · livraison fin novembre': 'Pre-order · levering eind november', 'Précommande · livraison mi-novembre': 'Pre-order · levering half november', 'Précommande · livraison mi-novembre - Quantités limitées': 'Pre-order · levering half november - Beperkte aantallen', 'Précommande · livraison fin novembre - Quantités limitées': 'Pre-order · levering eind november - Beperkte aantallen',
    // tailles
    "Petit - L'essentiel": 'Klein - Het essentiële', 'Medium - Équilibre parfait': 'Medium - Perfecte balans', "Grand - L'intégral": 'Groot - Alles erin',
    // rabats
    'Tweed Paon': 'Pauwblauwe tweed', 'Tweed noir et or': 'Zwart-gouden tweed', 'Tweed blanc': 'Witte tweed', 'Serpent multicolore': 'Veelkleurige slangenprint',
    'Noir': 'Zwart', 'Léopard': 'Luipaard', 'Jean': 'Denim', 'Blanc': 'Wit', 'Terracotta tissé': 'Geweven terracotta', 'Vert tissé kaki': 'Geweven kaki',
    'Turquoise': 'Turquoise', 'Tweed rose': 'Roze tweed', 'Tweed multicolore': 'Veelkleurige tweed', 'Tweed rouge': 'Rode tweed', 'Sable grainé': 'Zand generfd',
    'Bleu roi grainé': 'Koningsblauw generfd', 'Vert sapin grainé': 'Dennengroen generfd', 'Chocolat grainé': 'Chocolade generfd', 'Jean menthe': 'Mintgroen denim', 'Rose': 'Roze',
    // riemen
    'Bandoulière chic réglable': 'Verstelbare chique schouderriem', 'Sangle épaule confort': 'Comfortabele schouderriem',
    'Bandoulière confort réglable': 'Verstelbare comfortriem', 'Chaine épaule chic': 'Chique schouderketting', 'Anses noires incluses (+0 €)': 'Zwarte hengsels',
    // sluitingen
    'Ovale métal': 'Metalen ovaal', 'Ovale rouge': 'Rood ovaal', 'Ovale noir': 'Zwart ovaal', 'Diamant pailleté': 'Glitterdiamant', 'Nœud noir': 'Zwarte strik',
    'Coeur rouge': 'Rood hart', 'Coeur pailleté': 'Glitterhart', 'Coeur noir': 'Zwart hart', 'Rose rouge': 'Rode roos', 'Coeur doré': 'Gouden hart',
    'Coeur blanc': 'Wit hart', 'Ovale rose': 'Roze ovaal', 'Ovale blanc': 'Wit ovaal', 'Coeur - Vert sapin grainé': 'Hart - dennengroen generfd',
    'Coeur - Jean': 'Hart - denim', 'Coeur - Chocolat grainé': 'Hart - chocolade generfd', 'Coeur - Fuschia': 'Hart - fuchsia', 'Noeud blanc': 'Witte strik',
    'Coeur serpent multicolore': 'Hart met veelkleurige slangenprint',
    'Ovale rouge - perforé': 'Rood ovaal - geperforeerd', 'Ovale rose - perforé': 'Roze ovaal - geperforeerd', 'Ovale noir - perforé': 'Zwart ovaal - geperforeerd',
    'Rose rouge - perforée': 'Rode roos - geperforeerd', 'Coeur doré - perforé': 'Gouden hart - geperforeerd', 'Coeur pailleté - perforé': 'Glitterhart - geperforeerd',
    'Coeur noir - perforé': 'Zwart hart - geperforeerd', 'Coeur blanc - perforé': 'Wit hart - geperforeerd', 'Coeur rouge - perforé': 'Rood hart - geperforeerd',
    'Coeur - Vert sapin grainé perforé': 'Hart - dennengroen generfd - geperforeerd', 'Coeur - Jean perforé': 'Hart - denim - geperforeerd',
    'Coeur - Chocolat grainé perforé': 'Hart - chocolade generfd - geperforeerd', 'Coeur fuschia - perforé': 'Fuchsia hart - geperforeerd',
    'Coeur serpent multicolore - perforé': 'Hart met veelkleurige slangenprint - geperforeerd',
    // bedels
    'Clé': 'Sleutel', 'Sunshine - Blanc': 'Sunshine - wit', 'Sunshine - Noir': 'Sunshine - zwart', 'Goutte': 'Druppel',
    // portemonnees
    "Portefeuille - Feuille d'or": 'Portemonnee - bladgoud', 'Portefeuille - Serpent noir': 'Portemonnee - zwarte slangenprint',
    'Portefeuille - Serpent multicolore': 'Portemonnee - veelkleurige slangenprint', 'Portefeuille - Noir': 'Portemonnee - zwart',
    'Portefeuille - Jean': 'Portemonnee - denim', 'Portefeuille - Léopard': 'Portemonnee - luipaard', 'Portefeuille - Rouge': 'Portemonnee - rood',
  },
};

const EN = {
  locale: 'en-US',
  ord: ['1st', '2nd', '3rd'],
  ordH: ['1<sup>st</sup>', '2<sup>nd</sup>', '3<sup>rd</sup>'],
  ui: {
    loading: 'Loading…',
    loadError: "The bundle can't be loaded right now. Please refresh the page.",
    noLot: 'No bundle available.',
    ariaPreview: 'Bag preview',
    ariaNav: 'Bundle navigation',
    ariaSteps: 'Bundle steps',
    composeLot: 'Build your bundle at {badge}',
    seeRecap: 'See summary',
    hoverSizeHere: 'Hover over a size to see it here',
    captionWithFlap: '{size} · with the {flap} flap',
    captionFlapTodo: '{size} · flap to choose',
    captionStart: 'Choose your bag to get started',
    removeAria: 'Remove {name}',
    remove: 'Remove',
    flapN: '{ord} flap',
    toChoose: 'To choose',
    next: 'Next',
    checkout: 'Check out',
    addToSelectionN: 'Add to my selection ({n})',
    update: 'Update',
    addToSelection: 'Add to my selection',
    recap: 'Summary',
    adding: 'Adding…',
    added: '✓ Bundle added!',
    addToCart: 'Add to cart',
    deltaOnLot: '{delta} on your bundle',
    yourSelection: 'Your selection',
    chooseSize: 'Choose a size',
    fromPrice: 'from {price}',
    bagPlus3: 'Bag + 3 flaps',
    saved: '{amount} saved',
    shipBar: '+ Free shipping to a pickup point',
    prevStepAria: 'Previous step',
    prev: 'Back',
    stepBag: 'Bag',
    stepAccessories: 'Accessories',
    backTo: 'Back to: {step}',
    dimsTitle: 'Height × width × depth',
    included: 'Included: {items}',
    and: ' and ',
    inclClasp: '{name} clasp',
    lotBag3: 'Bundle: bag + 3 flaps',
    whichSize: 'Which bag size?',
    takenAria: '{name}, already chosen as {ord} flap',
    soldOutAria: '{name}, sold out',
    soldOut: 'Sold out',
    alreadyIncluded: 'Already in your bundle',
    includedAria: '{name}, already in your set',
    whichFlap: 'Choose your {ord} flap',
    prevFlapsAria: 'Previous flaps',
    nextFlapsAria: 'Next flaps',
    hoverSize: 'Hover over a size to see it on the left.',
    hoverFlap: 'Hover over a flap to try it on your bag.',
    askMore: 'Would you like to add more accessories at {pct}?',
    askAnother: 'Would you like to add another accessory at {pct}?',
    tickHint: 'Tick what you like: your accessories appear on the left. You can choose several.',
    accessoriesCount: { one: '{n} accessory', other: '{n} accessories' },
    selectionPlus: 'Your selection + {count}',
    whichAccessory: 'Which accessory?',
    cancel: 'Cancel',
    multiple: 'You can choose several',
    notChosen: 'Not chosen yet',
    edit: 'Change',
    accessoryOf: 'Accessory · {cat}',
    recapTitle: 'Your selection at {pct}',
    totalPrice: 'Total price: {price}',
    lotPrice: 'Bundle price: {price}',
    youSave: 'You save: {amount}',
    shipRecap: '<b>Bonus with your bundle</b>: free shipping to a pickup point.',
    addAccessory: '+ Add an accessory at {pct}',
    chooseFlapsHint: 'Choose your 3 flaps to add the bundle to your cart.',
    doneTitle: 'Your bundle is in your cart',
    doneSave: 'You saved {amount}.',
    doneSaveShip: 'You saved {amount}, and shipping to a pickup point is free.',
    another: 'Build another bundle',
    continueShopping: 'Continue shopping',
    cartError: "The bundle couldn't be added to your cart",
    cartWarning: 'Your bundle is in your cart, but one accessory is no longer available and was not added.',
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Clasps',
    charmFirst: 'Choose your charm first',
    claspStep1: 'Choose your perforated clasp',
    claspQ: 'With or without a charm?',
    claspNo: 'No charm',
    claspNoHint: 'Clasp without a hole',
    claspYes: 'With a charm',
    claspYesHint: 'Perforated clasp + a charm to hang',
    charmPick: 'Choose your charm: it hangs from the hole in the clasp.',
    charmMissing: 'Your perforated clasp needs a charm: without one, the hole stays empty.',
    charmCta: 'Choose a charm',
  },
  terms: {
    'Rabats': 'Flaps', 'Sangles': 'Straps', 'Fermoir non perforé': 'Clasps', 'Fermoir perforé': 'Perforated clasps',
    'Charms': 'Charms', 'Portefeuille': 'Wallets', 'Précommande · livraison fin novembre': 'Pre-order · ships late November', 'Précommande · livraison mi-novembre': 'Pre-order · ships mid-November', 'Précommande · livraison mi-novembre - Quantités limitées': 'Pre-order · ships mid-November - Limited quantities', 'Précommande · livraison fin novembre - Quantités limitées': 'Pre-order · ships late November - Limited quantities',
    "Petit - L'essentiel": 'Small - The Essential', 'Medium - Équilibre parfait': 'Medium - Perfect Balance', "Grand - L'intégral": 'Large - The Complete',
    'Tweed Paon': 'Peacock tweed', 'Tweed noir et or': 'Black and gold tweed', 'Tweed blanc': 'White tweed', 'Serpent multicolore': 'Multicolor snake',
    'Noir': 'Black', 'Léopard': 'Leopard', 'Jean': 'Denim', 'Blanc': 'White', 'Terracotta tissé': 'Woven terracotta', 'Vert tissé kaki': 'Woven khaki',
    'Turquoise': 'Turquoise', 'Tweed rose': 'Pink tweed', 'Tweed multicolore': 'Multicolor tweed', 'Tweed rouge': 'Red tweed', 'Sable grainé': 'Grained sand',
    'Bleu roi grainé': 'Grained royal blue', 'Vert sapin grainé': 'Grained fir green', 'Chocolat grainé': 'Grained chocolate', 'Jean menthe': 'Mint denim', 'Rose': 'Pink',
    'Bandoulière chic réglable': 'Adjustable chic shoulder strap', 'Sangle épaule confort': 'Comfort shoulder strap',
    'Bandoulière confort réglable': 'Adjustable comfort strap', 'Chaine épaule chic': 'Chic shoulder chain', 'Anses noires incluses (+0 €)': 'Black handles',
    'Ovale métal': 'Metal oval', 'Ovale rouge': 'Red oval', 'Ovale noir': 'Black oval', 'Diamant pailleté': 'Glitter diamond', 'Nœud noir': 'Black bow',
    'Coeur rouge': 'Red heart', 'Coeur pailleté': 'Glitter heart', 'Coeur noir': 'Black heart', 'Rose rouge': 'Red rose', 'Coeur doré': 'Gold heart',
    'Coeur blanc': 'White heart', 'Ovale rose': 'Pink oval', 'Ovale blanc': 'White oval', 'Coeur - Vert sapin grainé': 'Heart - grained fir green',
    'Coeur - Jean': 'Heart - denim', 'Coeur - Chocolat grainé': 'Heart - grained chocolate', 'Coeur - Fuschia': 'Heart - fuchsia', 'Noeud blanc': 'White bow',
    'Coeur serpent multicolore': 'Multicolor snake heart',
    'Ovale rouge - perforé': 'Red oval - perforated', 'Ovale rose - perforé': 'Pink oval - perforated', 'Ovale noir - perforé': 'Black oval - perforated',
    'Rose rouge - perforée': 'Red rose - perforated', 'Coeur doré - perforé': 'Gold heart - perforated', 'Coeur pailleté - perforé': 'Glitter heart - perforated',
    'Coeur noir - perforé': 'Black heart - perforated', 'Coeur blanc - perforé': 'White heart - perforated', 'Coeur rouge - perforé': 'Red heart - perforated',
    'Coeur - Vert sapin grainé perforé': 'Heart - grained fir green, perforated', 'Coeur - Jean perforé': 'Heart - denim, perforated',
    'Coeur - Chocolat grainé perforé': 'Heart - grained chocolate, perforated', 'Coeur fuschia - perforé': 'Fuchsia heart - perforated',
    'Coeur serpent multicolore - perforé': 'Multicolor snake heart - perforated',
    'Clé': 'Key', 'Sunshine - Blanc': 'Sunshine - white', 'Sunshine - Noir': 'Sunshine - black', 'Goutte': 'Drop',
    "Portefeuille - Feuille d'or": 'Wallet - gold leaf', 'Portefeuille - Serpent noir': 'Wallet - black snake',
    'Portefeuille - Serpent multicolore': 'Wallet - multicolor snake', 'Portefeuille - Noir': 'Wallet - black',
    'Portefeuille - Jean': 'Wallet - denim', 'Portefeuille - Léopard': 'Wallet - leopard', 'Portefeuille - Rouge': 'Wallet - red',
  },
};

const ES = {
  locale: 'es-ES',
  ord: ['1.ª', '2.ª', '3.ª'],
  ordH: ['1.<sup>ª</sup>', '2.<sup>ª</sup>', '3.<sup>ª</sup>'],
  ui: {
    loading: 'Cargando…',
    loadError: 'No se puede cargar el lote en este momento. Recarga la página.',
    noLot: 'No hay ningún lote disponible.',
    ariaPreview: 'Vista previa del bolso',
    ariaNav: 'Navegación del lote',
    ariaSteps: 'Pasos del lote',
    composeLot: 'Crea tu lote con un {badge}',
    seeRecap: 'Ver el resumen',
    hoverSizeHere: 'Pasa el ratón por un tamaño para verlo aquí',
    captionWithFlap: '{size} · con la solapa {flap}',
    captionFlapTodo: '{size} · solapa por elegir',
    captionStart: 'Elige tu bolso para empezar',
    removeAria: 'Quitar {name}',
    remove: 'Quitar',
    flapN: '{ord} solapa',
    toChoose: 'Por elegir',
    next: 'Siguiente',
    checkout: 'Finalizar mi pedido',
    addToSelectionN: 'Añadir a mi selección ({n})',
    update: 'Actualizar',
    addToSelection: 'Añadir a mi selección',
    recap: 'Resumen',
    adding: 'Añadiendo…',
    added: '✓ ¡Lote añadido!',
    addToCart: 'Añadir al carrito',
    deltaOnLot: '{delta} en tu lote',
    yourSelection: 'Tu selección',
    chooseSize: 'Elige un tamaño',
    fromPrice: 'desde {price}',
    bagPlus3: 'Bolso + 3 solapas',
    saved: '{amount} de ahorro',
    shipBar: '+ Envío gratis a punto de recogida',
    prevStepAria: 'Paso anterior',
    prev: 'Anterior',
    stepBag: 'Bolso',
    stepAccessories: 'Accesorios',
    backTo: 'Volver a: {step}',
    dimsTitle: 'Alto × ancho × fondo',
    included: 'Incluye: {items}',
    and: ' y ',
    inclClasp: 'cierre {name}',
    lotBag3: 'Lote bolso + 3 solapas',
    whichSize: '¿Qué tamaño de bolso?',
    takenAria: '{name}, ya elegida como {ord} solapa',
    soldOutAria: '{name}, agotada',
    soldOut: 'Agotado',
    alreadyIncluded: 'Ya incluido en tu lote',
    includedAria: '{name}, ya incluido en tu lote',
    whichFlap: 'Elige tu {ord} solapa',
    prevFlapsAria: 'Solapas anteriores',
    nextFlapsAria: 'Solapas siguientes',
    hoverSize: 'Pasa el ratón por un tamaño para verlo a la izquierda.',
    hoverFlap: 'Pasa el ratón por una solapa para probarla en tu bolso.',
    askMore: '¿Quieres añadir más accesorios con un {pct}?',
    askAnother: '¿Quieres añadir otro accesorio con un {pct}?',
    tickHint: 'Marca lo que te guste: tus accesorios aparecen a la izquierda. Puedes elegir varios.',
    accessoriesCount: { one: '{n} accesorio', other: '{n} accesorios' },
    selectionPlus: 'Tu selección + {count}',
    whichAccessory: '¿Qué accesorio?',
    cancel: 'Cancelar',
    multiple: 'Puedes elegir varios',
    notChosen: 'Aún sin elegir',
    edit: 'Cambiar',
    accessoryOf: 'Accesorio · {cat}',
    recapTitle: 'Tu selección con un {pct}',
    totalPrice: 'Precio total: {price}',
    lotPrice: 'Precio del lote: {price}',
    youSave: 'Ahorras: {amount}',
    shipRecap: '<b>Además, gracias a tu lote</b>, el envío a punto de recogida es gratis.',
    addAccessory: '+ Añadir un accesorio con un {pct}',
    chooseFlapsHint: 'Elige tus 3 solapas para añadir el lote al carrito.',
    doneTitle: 'Tu lote ya está en el carrito',
    doneSave: 'Has ahorrado {amount}.',
    doneSaveShip: 'Has ahorrado {amount}, y el envío a punto de recogida es gratis.',
    another: 'Crear otro lote',
    continueShopping: 'Seguir comprando',
    cartError: 'No se ha podido añadir el lote al carrito',
    cartWarning: 'Tu lote está en el carrito, pero un accesorio ya no está disponible y no se ha añadido.',
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Cierres',
    charmFirst: 'Elige primero tu charm',
    claspStep1: 'Elige tu cierre perforado',
    claspQ: '¿Con o sin charm?',
    claspNo: 'Sin charm',
    claspNoHint: 'Cierre sin agujero',
    claspYes: 'Con un charm',
    claspYesHint: 'Cierre perforado + charm para colgar',
    charmPick: 'Elige tu charm: se cuelga del agujero del cierre.',
    charmMissing: 'Tu cierre perforado necesita un charm: sin él, el agujero queda vacío.',
    charmCta: 'Elegir un charm',
  },
  terms: {
    'Rabats': 'Solapas', 'Sangles': 'Correas', 'Fermoir non perforé': 'Cierres', 'Fermoir perforé': 'Cierres perforados',
    'Charms': 'Charms', 'Portefeuille': 'Carteras', 'Précommande · livraison fin novembre': 'Preventa · entrega a finales de noviembre', 'Précommande · livraison mi-novembre': 'Preventa · entrega a mediados de noviembre', 'Précommande · livraison mi-novembre - Quantités limitées': 'Preventa · entrega a mediados de noviembre - Cantidades limitadas', 'Précommande · livraison fin novembre - Quantités limitées': 'Preventa · entrega a finales de noviembre - Cantidades limitadas',
    "Petit - L'essentiel": 'Pequeño - Lo esencial', 'Medium - Équilibre parfait': 'Mediano - Equilibrio perfecto', "Grand - L'intégral": 'Grande - El completo',
    'Tweed Paon': 'Tweed pavo real', 'Tweed noir et or': 'Tweed negro y dorado', 'Tweed blanc': 'Tweed blanco', 'Serpent multicolore': 'Serpiente multicolor',
    'Noir': 'Negro', 'Léopard': 'Leopardo', 'Jean': 'Vaquero', 'Blanc': 'Blanco', 'Terracotta tissé': 'Terracota tejido', 'Vert tissé kaki': 'Caqui tejido',
    'Turquoise': 'Turquesa', 'Tweed rose': 'Tweed rosa', 'Tweed multicolore': 'Tweed multicolor', 'Tweed rouge': 'Tweed rojo', 'Sable grainé': 'Arena granulado',
    'Bleu roi grainé': 'Azul real granulado', 'Vert sapin grainé': 'Verde abeto granulado', 'Chocolat grainé': 'Chocolate granulado', 'Jean menthe': 'Vaquero menta', 'Rose': 'Rosa',
    'Bandoulière chic réglable': 'Bandolera chic ajustable', 'Sangle épaule confort': 'Correa de hombro confort',
    'Bandoulière confort réglable': 'Bandolera confort ajustable', 'Chaine épaule chic': 'Cadena de hombro chic', 'Anses noires incluses (+0 €)': 'Asas negras',
    'Ovale métal': 'Óvalo metálico', 'Ovale rouge': 'Óvalo rojo', 'Ovale noir': 'Óvalo negro', 'Diamant pailleté': 'Diamante con purpurina', 'Nœud noir': 'Lazo negro',
    'Coeur rouge': 'Corazón rojo', 'Coeur pailleté': 'Corazón con purpurina', 'Coeur noir': 'Corazón negro', 'Rose rouge': 'Rosa roja', 'Coeur doré': 'Corazón dorado',
    'Coeur blanc': 'Corazón blanco', 'Ovale rose': 'Óvalo rosa', 'Ovale blanc': 'Óvalo blanco', 'Coeur - Vert sapin grainé': 'Corazón - verde abeto granulado',
    'Coeur - Jean': 'Corazón - vaquero', 'Coeur - Chocolat grainé': 'Corazón - chocolate granulado', 'Coeur - Fuschia': 'Corazón - fucsia', 'Noeud blanc': 'Lazo blanco',
    'Coeur serpent multicolore': 'Corazón serpiente multicolor',
    'Ovale rouge - perforé': 'Óvalo rojo - perforado', 'Ovale rose - perforé': 'Óvalo rosa - perforado', 'Ovale noir - perforé': 'Óvalo negro - perforado',
    'Rose rouge - perforée': 'Rosa roja - perforada', 'Coeur doré - perforé': 'Corazón dorado - perforado', 'Coeur pailleté - perforé': 'Corazón con purpurina - perforado',
    'Coeur noir - perforé': 'Corazón negro - perforado', 'Coeur blanc - perforé': 'Corazón blanco - perforado', 'Coeur rouge - perforé': 'Corazón rojo - perforado',
    'Coeur - Vert sapin grainé perforé': 'Corazón - verde abeto granulado, perforado', 'Coeur - Jean perforé': 'Corazón - vaquero, perforado',
    'Coeur - Chocolat grainé perforé': 'Corazón - chocolate granulado, perforado', 'Coeur fuschia - perforé': 'Corazón fucsia - perforado',
    'Coeur serpent multicolore - perforé': 'Corazón serpiente multicolor - perforado',
    'Clé': 'Llave', 'Sunshine - Blanc': 'Sunshine - blanco', 'Sunshine - Noir': 'Sunshine - negro', 'Goutte': 'Gota',
    "Portefeuille - Feuille d'or": 'Cartera - pan de oro', 'Portefeuille - Serpent noir': 'Cartera - serpiente negra',
    'Portefeuille - Serpent multicolore': 'Cartera - serpiente multicolor', 'Portefeuille - Noir': 'Cartera - negro',
    'Portefeuille - Jean': 'Cartera - vaquero', 'Portefeuille - Léopard': 'Cartera - leopardo', 'Portefeuille - Rouge': 'Cartera - rojo',
  },
};

const IT = {
  locale: 'it-IT',
  ord: ['1ª', '2ª', '3ª'],
  ordH: ['1<sup>a</sup>', '2<sup>a</sup>', '3<sup>a</sup>'],
  ui: {
    loading: 'Caricamento…',
    loadError: 'Al momento non è possibile caricare il set. Ricarica la pagina.',
    noLot: 'Nessun set disponibile.',
    ariaPreview: 'Anteprima della borsa',
    ariaNav: 'Navigazione del set',
    ariaSteps: 'Passaggi del set',
    composeLot: 'Crea il tuo set al {badge}',
    seeRecap: 'Vedi il riepilogo',
    hoverSizeHere: 'Passa il mouse su una misura per vederla qui',
    captionWithFlap: '{size} · con la patta {flap}',
    captionFlapTodo: '{size} · patta da scegliere',
    captionStart: 'Scegli la tua borsa per iniziare',
    removeAria: 'Rimuovi {name}',
    remove: 'Rimuovi',
    flapN: '{ord} patta',
    toChoose: 'Da scegliere',
    next: 'Avanti',
    checkout: 'Completa il mio ordine',
    addToSelectionN: 'Aggiungi alla mia selezione ({n})',
    update: 'Aggiorna',
    addToSelection: 'Aggiungi alla mia selezione',
    recap: 'Riepilogo',
    adding: 'Aggiunta in corso…',
    added: '✓ Set aggiunto!',
    addToCart: 'Aggiungi al carrello',
    deltaOnLot: '{delta} sul tuo set',
    yourSelection: 'La tua selezione',
    chooseSize: 'Scegli una misura',
    fromPrice: 'da {price}',
    bagPlus3: 'Borsa + 3 patte',
    saved: '{amount} risparmiati',
    shipBar: '+ Spedizione gratuita al punto di ritiro',
    prevStepAria: 'Passaggio precedente',
    prev: 'Indietro',
    stepBag: 'Borsa',
    stepAccessories: 'Accessori',
    backTo: 'Torna a: {step}',
    dimsTitle: 'Altezza × larghezza × profondità',
    included: 'Incluso: {items}',
    and: ' e ',
    inclClasp: 'chiusura {name}',
    lotBag3: 'Set borsa + 3 patte',
    whichSize: 'Quale misura di borsa?',
    takenAria: '{name}, già scelta come {ord} patta',
    soldOutAria: '{name}, esaurita',
    soldOut: 'Esaurito',
    alreadyIncluded: 'Già nel tuo set',
    includedAria: '{name}, già incluso nel set',
    whichFlap: 'Scegli la tua {ord} patta',
    prevFlapsAria: 'Patte precedenti',
    nextFlapsAria: 'Patte successive',
    hoverSize: 'Passa il mouse su una misura per vederla a sinistra.',
    hoverFlap: 'Passa il mouse su una patta per provarla sulla tua borsa.',
    askMore: 'Vuoi aggiungere altri accessori al {pct}?',
    askAnother: 'Vuoi aggiungere un altro accessorio al {pct}?',
    tickHint: 'Seleziona quello che ti piace: i tuoi accessori compaiono a sinistra. Puoi sceglierne più di uno.',
    accessoriesCount: { one: '{n} accessorio', other: '{n} accessori' },
    selectionPlus: 'La tua selezione + {count}',
    whichAccessory: 'Quale accessorio?',
    cancel: 'Annulla',
    multiple: 'Puoi sceglierne più di uno',
    notChosen: 'Non ancora scelta',
    edit: 'Modifica',
    accessoryOf: 'Accessorio · {cat}',
    recapTitle: 'La tua selezione al {pct}',
    totalPrice: 'Prezzo totale: {price}',
    lotPrice: 'Prezzo del set: {price}',
    youSave: 'Risparmi: {amount}',
    shipRecap: '<b>In più, grazie al tuo set</b>, la spedizione al punto di ritiro è gratuita.',
    addAccessory: '+ Aggiungi un accessorio al {pct}',
    chooseFlapsHint: 'Scegli le tue 3 patte per aggiungere il set al carrello.',
    doneTitle: 'Il tuo set è nel carrello',
    doneSave: 'Hai risparmiato {amount}.',
    doneSaveShip: 'Hai risparmiato {amount}, e la spedizione al punto di ritiro è gratuita.',
    another: 'Crea un altro set',
    continueShopping: 'Continua lo shopping',
    cartError: 'Non è stato possibile aggiungere il set al carrello',
    cartWarning: 'Il tuo set è nel carrello, ma un accessorio non è più disponibile e non è stato aggiunto.',
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Chiusure',
    charmFirst: 'Scegli prima il tuo charm',
    claspStep1: 'Scegli la tua chiusura forata',
    claspQ: 'Con o senza charm?',
    claspNo: 'Senza charm',
    claspNoHint: 'Chiusura senza foro',
    claspYes: 'Con un charm',
    claspYesHint: 'Chiusura forata + charm da appendere',
    charmPick: 'Scegli il tuo charm: si aggancia al foro della chiusura.',
    charmMissing: 'La tua chiusura forata aspetta un charm: senza, il foro resta vuoto.',
    charmCta: 'Scegli un charm',
  },
  terms: {
    'Rabats': 'Patte', 'Sangles': 'Tracolle', 'Fermoir non perforé': 'Chiusure', 'Fermoir perforé': 'Chiusure forate',
    'Charms': 'Charm', 'Portefeuille': 'Portafogli', 'Précommande · livraison fin novembre': 'Preordine · consegna a fine novembre', 'Précommande · livraison mi-novembre': 'Preordine · consegna a metà novembre', 'Précommande · livraison mi-novembre - Quantités limitées': 'Preordine · consegna a metà novembre - Quantità limitate', 'Précommande · livraison fin novembre - Quantités limitées': 'Preordine · consegna a fine novembre - Quantità limitate',
    "Petit - L'essentiel": "Piccola - L'essenziale", 'Medium - Équilibre parfait': 'Media - Equilibrio perfetto', "Grand - L'intégral": "Grande - L'integrale",
    'Tweed Paon': 'Tweed pavone', 'Tweed noir et or': 'Tweed nero e oro', 'Tweed blanc': 'Tweed bianco', 'Serpent multicolore': 'Pitone multicolore',
    'Noir': 'Nero', 'Léopard': 'Leopardato', 'Jean': 'Denim', 'Blanc': 'Bianco', 'Terracotta tissé': 'Terracotta intrecciato', 'Vert tissé kaki': 'Kaki intrecciato',
    'Turquoise': 'Turchese', 'Tweed rose': 'Tweed rosa', 'Tweed multicolore': 'Tweed multicolore', 'Tweed rouge': 'Tweed rosso', 'Sable grainé': 'Sabbia martellato',
    'Bleu roi grainé': 'Blu reale martellato', 'Vert sapin grainé': 'Verde abete martellato', 'Chocolat grainé': 'Cioccolato martellato', 'Jean menthe': 'Denim menta', 'Rose': 'Rosa',
    'Bandoulière chic réglable': 'Tracolla chic regolabile', 'Sangle épaule confort': 'Spallaccio comfort',
    'Bandoulière confort réglable': 'Tracolla comfort regolabile', 'Chaine épaule chic': 'Catena a spalla chic', 'Anses noires incluses (+0 €)': 'Manici neri',
    'Ovale métal': 'Ovale in metallo', 'Ovale rouge': 'Ovale rosso', 'Ovale noir': 'Ovale nero', 'Diamant pailleté': 'Diamante glitter', 'Nœud noir': 'Fiocco nero',
    'Coeur rouge': 'Cuore rosso', 'Coeur pailleté': 'Cuore glitter', 'Coeur noir': 'Cuore nero', 'Rose rouge': 'Rosa rossa', 'Coeur doré': 'Cuore dorato',
    'Coeur blanc': 'Cuore bianco', 'Ovale rose': 'Ovale rosa', 'Ovale blanc': 'Ovale bianco', 'Coeur - Vert sapin grainé': 'Cuore - verde abete martellato',
    'Coeur - Jean': 'Cuore - denim', 'Coeur - Chocolat grainé': 'Cuore - cioccolato martellato', 'Coeur - Fuschia': 'Cuore - fucsia', 'Noeud blanc': 'Fiocco bianco',
    'Coeur serpent multicolore': 'Cuore pitone multicolore',
    'Ovale rouge - perforé': 'Ovale rosso - forato', 'Ovale rose - perforé': 'Ovale rosa - forato', 'Ovale noir - perforé': 'Ovale nero - forato',
    'Rose rouge - perforée': 'Rosa rossa - forata', 'Coeur doré - perforé': 'Cuore dorato - forato', 'Coeur pailleté - perforé': 'Cuore glitter - forato',
    'Coeur noir - perforé': 'Cuore nero - forato', 'Coeur blanc - perforé': 'Cuore bianco - forato', 'Coeur rouge - perforé': 'Cuore rosso - forato',
    'Coeur - Vert sapin grainé perforé': 'Cuore - verde abete martellato, forato', 'Coeur - Jean perforé': 'Cuore - denim, forato',
    'Coeur - Chocolat grainé perforé': 'Cuore - cioccolato martellato, forato', 'Coeur fuschia - perforé': 'Cuore fucsia - forato',
    'Coeur serpent multicolore - perforé': 'Cuore pitone multicolore - forato',
    'Clé': 'Chiave', 'Sunshine - Blanc': 'Sunshine - bianco', 'Sunshine - Noir': 'Sunshine - nero', 'Goutte': 'Goccia',
    "Portefeuille - Feuille d'or": 'Portafoglio - foglia oro', 'Portefeuille - Serpent noir': 'Portafoglio - pitone nero',
    'Portefeuille - Serpent multicolore': 'Portafoglio - pitone multicolore', 'Portefeuille - Noir': 'Portafoglio - nero',
    'Portefeuille - Jean': 'Portafoglio - denim', 'Portefeuille - Léopard': 'Portafoglio - leopardato', 'Portefeuille - Rouge': 'Portafoglio - rosso',
  },
};

// Allemand (23/10/2026, avant les pubs en Allemagne) : vocabulaire donné par la session andjoy-site-e0 (Set, Klappe,
// Riemen, Verschluss, Anhänger, Tasche, Paketshop), tutoiement (du). Jamais « Leder » seul : « veganes Kunstleder ».
const DE = {
  locale: 'de-DE',
  ord: ['1.', '2.', '3.'],
  ordH: ['1.', '2.', '3.'],
  ui: {
    loading: 'Wird geladen…',
    loadError: 'Das Set kann gerade nicht geladen werden. Lade die Seite bitte neu.',
    noLot: 'Kein Set verfügbar.',
    ariaPreview: 'Vorschau deiner Tasche',
    ariaNav: 'Navigation des Sets',
    ariaSteps: 'Schritte des Sets',
    composeLot: 'Stell dein Set mit {badge} zusammen',
    seeRecap: 'Zur Übersicht',
    hoverSizeHere: 'Fahre über eine Größe, um sie hier zu sehen',
    captionWithFlap: '{size} · mit der Klappe {flap}',
    captionFlapTodo: '{size} · Klappe noch zu wählen',
    captionStart: 'Wähle deine Tasche, um loszulegen',
    removeAria: '{name} entfernen',
    remove: 'Entfernen',
    flapN: '{ord} Klappe',
    toChoose: 'Noch zu wählen',
    next: 'Weiter',
    checkout: 'Zur Kasse',
    addToSelectionN: 'Zu meiner Auswahl hinzufügen ({n})',
    update: 'Aktualisieren',
    addToSelection: 'Zu meiner Auswahl hinzufügen',
    recap: 'Übersicht',
    adding: 'Wird hinzugefügt…',
    added: '✓ Set hinzugefügt!',
    addToCart: 'In den Warenkorb',
    deltaOnLot: '{delta} auf dein Set',
    yourSelection: 'Deine Auswahl',
    chooseSize: 'Wähle eine Größe',
    fromPrice: 'ab {price}',
    bagPlus3: 'Tasche + 3 Klappen',
    saved: '{amount} gespart',
    shipBar: '+ Kostenloser Versand an einen Paketshop',
    prevStepAria: 'Vorheriger Schritt',
    prev: 'Zurück',
    stepBag: 'Tasche',
    stepAccessories: 'Accessoires',
    backTo: 'Zurück zu: {step}',
    dimsTitle: 'Höhe × Breite × Tiefe',
    included: 'Inklusive: {items}',
    and: ' und ',
    inclClasp: 'Verschluss {name}',
    lotBag3: 'Set: Tasche + 3 Klappen',
    whichSize: 'Welche Taschengröße?',
    takenAria: '{name}, schon als {ord} Klappe gewählt',
    soldOutAria: '{name}, ausverkauft',
    soldOut: 'Ausverkauft',
    alreadyIncluded: 'Schon in deinem Set',
    includedAria: '{name}, schon in deinem Set',
    whichFlap: 'Wähle deine {ord} Klappe',
    prevFlapsAria: 'Vorherige Klappen',
    nextFlapsAria: 'Nächste Klappen',
    hoverSize: 'Fahre über eine Größe, um sie links zu sehen.',
    hoverFlap: 'Fahre über eine Klappe, um sie an deiner Tasche auszuprobieren.',
    askMore: 'Möchtest du weitere Accessoires mit {pct} hinzufügen?',
    askAnother: 'Möchtest du noch ein Accessoire mit {pct} hinzufügen?',
    tickHint: 'Hake an, was dir gefällt: Deine Accessoires erscheinen links. Du kannst mehrere wählen.',
    accessoriesCount: { one: '{n} Accessoire', other: '{n} Accessoires' },
    selectionPlus: 'Deine Auswahl + {count}',
    whichAccessory: 'Welches Accessoire?',
    cancel: 'Abbrechen',
    multiple: 'Du kannst mehrere wählen',
    notChosen: 'Noch nicht gewählt',
    edit: 'Ändern',
    accessoryOf: 'Accessoire · {cat}',
    recapTitle: 'Deine Auswahl mit {pct}',
    totalPrice: 'Gesamtpreis: {price}',
    lotPrice: 'Preis des Sets: {price}',
    youSave: 'Du sparst: {amount}',
    shipRecap: '<b>Dazu dank deines Sets</b>: kostenloser Versand an einen Paketshop.',
    addAccessory: '+ Accessoire mit {pct} hinzufügen',
    chooseFlapsHint: 'Wähle deine 3 Klappen, um das Set in den Warenkorb zu legen.',
    doneTitle: 'Dein Set liegt im Warenkorb',
    doneSave: 'Du hast {amount} gespart.',
    doneSaveShip: 'Du hast {amount} gespart, und der Versand an einen Paketshop ist kostenlos.',
    another: 'Noch ein Set zusammenstellen',
    continueShopping: 'Weiter einkaufen',
    cartError: 'Das Set konnte nicht in den Warenkorb gelegt werden',
    cartWarning: 'Dein Set liegt im Warenkorb, aber ein Accessoire ist nicht mehr verfügbar und wurde nicht hinzugefügt.',
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Verschlüsse',
    charmFirst: 'Wähle zuerst deinen Anhänger',
    claspStep1: 'Wähle deinen gelochten Verschluss',
    claspQ: 'Mit oder ohne Anhänger?',
    claspNo: 'Ohne Anhänger',
    claspNoHint: 'Verschluss ohne Loch',
    claspYes: 'Mit Anhänger',
    claspYesHint: 'Gelochter Verschluss + Anhänger zum Einhängen',
    charmPick: 'Wähle deinen Anhänger: Er wird in das Loch des Verschlusses gehängt.',
    charmMissing: 'Dein gelochter Verschluss wartet noch auf einen Anhänger: Ohne bleibt das Loch leer.',
    charmCta: 'Anhänger wählen',
  },
  terms: {
    'Rabats': 'Klappen', 'Sangles': 'Riemen', 'Fermoir non perforé': 'Verschlüsse', 'Fermoir perforé': 'Gelochte Verschlüsse',
    'Charms': 'Anhänger', 'Portefeuille': 'Geldbörsen', 'Précommande · livraison fin novembre': 'Vorbestellung · Lieferung Ende November', 'Précommande · livraison mi-novembre': 'Vorbestellung · Lieferung Mitte November', 'Précommande · livraison mi-novembre - Quantités limitées': 'Vorbestellung · Lieferung Mitte November - Begrenzte Stückzahl', 'Précommande · livraison fin novembre - Quantités limitées': 'Vorbestellung · Lieferung Ende November - Begrenzte Stückzahl',
    "Petit - L'essentiel": 'Klein - Das Wesentliche', 'Medium - Équilibre parfait': 'Mittel - Perfekte Balance', "Grand - L'intégral": 'Groß - Alles drin',
    'Tweed Paon': 'Pfauenblauer Tweed', 'Tweed noir et or': 'Tweed Schwarz-Gold', 'Tweed blanc': 'Weißer Tweed', 'Serpent multicolore': 'Bunte Schlangenoptik',
    'Noir': 'Schwarz', 'Léopard': 'Leopard', 'Jean': 'Denim', 'Blanc': 'Weiß', 'Terracotta tissé': 'Terrakotta geflochten', 'Vert tissé kaki': 'Khaki geflochten',
    'Turquoise': 'Türkis', 'Tweed rose': 'Rosa Tweed', 'Tweed multicolore': 'Bunter Tweed', 'Tweed rouge': 'Roter Tweed', 'Sable grainé': 'Sand genarbt',
    'Bleu roi grainé': 'Königsblau genarbt', 'Vert sapin grainé': 'Tannengrün genarbt', 'Chocolat grainé': 'Schokobraun genarbt', 'Jean menthe': 'Mint-Denim', 'Rose': 'Rosa',
    'Bandoulière chic réglable': 'Verstellbarer Umhängeriemen Chic', 'Sangle épaule confort': 'Bequemer Schulterriemen',
    'Bandoulière confort réglable': 'Verstellbarer Umhängeriemen Komfort', 'Chaine épaule chic': 'Schicke Schulterkette', 'Anses noires incluses (+0 €)': 'Schwarze Henkel',
    'Ovale métal': 'Metall-Oval', 'Ovale rouge': 'Rotes Oval', 'Ovale noir': 'Schwarzes Oval', 'Diamant pailleté': 'Glitzerdiamant', 'Nœud noir': 'Schwarze Schleife',
    'Coeur rouge': 'Rotes Herz', 'Coeur pailleté': 'Glitzerherz', 'Coeur noir': 'Schwarzes Herz', 'Rose rouge': 'Rote Rose', 'Coeur doré': 'Goldenes Herz',
    'Coeur blanc': 'Weißes Herz', 'Ovale rose': 'Rosa Oval', 'Ovale blanc': 'Weißes Oval', 'Coeur - Vert sapin grainé': 'Herz - Tannengrün genarbt',
    'Coeur - Jean': 'Herz - Denim', 'Coeur - Chocolat grainé': 'Herz - Schokobraun genarbt', 'Coeur - Fuschia': 'Herz - Fuchsia', 'Noeud blanc': 'Weiße Schleife',
    'Coeur serpent multicolore': 'Herz in bunter Schlangenoptik',
    'Ovale rouge - perforé': 'Rotes Oval - gelocht', 'Ovale rose - perforé': 'Rosa Oval - gelocht', 'Ovale noir - perforé': 'Schwarzes Oval - gelocht',
    'Rose rouge - perforée': 'Rote Rose - gelocht', 'Coeur doré - perforé': 'Goldenes Herz - gelocht', 'Coeur pailleté - perforé': 'Glitzerherz - gelocht',
    'Coeur noir - perforé': 'Schwarzes Herz - gelocht', 'Coeur blanc - perforé': 'Weißes Herz - gelocht', 'Coeur rouge - perforé': 'Rotes Herz - gelocht',
    'Coeur - Vert sapin grainé perforé': 'Herz - Tannengrün genarbt, gelocht', 'Coeur - Jean perforé': 'Herz - Denim, gelocht',
    'Coeur - Chocolat grainé perforé': 'Herz - Schokobraun genarbt, gelocht', 'Coeur fuschia - perforé': 'Fuchsia-Herz - gelocht',
    'Coeur serpent multicolore - perforé': 'Herz in bunter Schlangenoptik - gelocht',
    'Clé': 'Schlüssel', 'Sunshine - Blanc': 'Sunshine - Weiß', 'Sunshine - Noir': 'Sunshine - Schwarz', 'Goutte': 'Tropfen',
    "Portefeuille - Feuille d'or": 'Geldbörse - Blattgold', 'Portefeuille - Serpent noir': 'Geldbörse - schwarze Schlangenoptik',
    'Portefeuille - Serpent multicolore': 'Geldbörse - bunte Schlangenoptik', 'Portefeuille - Noir': 'Geldbörse - Schwarz',
    'Portefeuille - Jean': 'Geldbörse - Denim', 'Portefeuille - Léopard': 'Geldbörse - Leopard', 'Portefeuille - Rouge': 'Geldbörse - Rot',
  },
};

export default { nl: NL, en: EN, es: ES, it: IT, de: DE };
